export default {
    get API_URL() {
        return process.env.VUE_APP_API_URL;
    },
    getVersion: function () {
        return fetch(this.API_URL + '/kiosk/version', {
            headers: { 'Accept': 'application/json' },
        }).then(data => data.json()).catch(function () {
            return false;
        });
    },
}
